export const RESET_ONBOARDING_STEPS = 'RESET_ONBOARDING_STEPS';
export const ADD_ONBOARDING_STEPS = 'ADD_ONBOARDING_STEPS';
export const NEXT_ONBOARDING_STEP = 'NEXT_ONBOARDING_STEP';
